import React from 'react'
import {
  CardProps,
  CardHeaderProps,
  CardTitleProps,
  CardBodyProps,
  CardFooterProps,
  DataGridProps,
  DataGroupProps,
  DataRowProps,
  DataSectionTitleProps,
} from './Card.types'
import {
  StyledCard,
  StyledCardHeader,
  StyledCardTitle,
  StyledCardBody,
  StyledCardFooter,
  StyledDataGrid,
  StyledDataGroup,
  StyledDataRow,
  StyledDataLabel,
  StyledDataValue,
  StyledDataSectionTitle,
} from './Card.styles'

export const Card: React.FC<CardProps> = ({ children, className, id }) => {
  return (
    <StyledCard className={className} id={id}>
      {children}
    </StyledCard>
  )
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  action,
  className,
}) => {
  return (
    <StyledCardHeader className={className}>
      {children}
      {action && <div>{action}</div>}
    </StyledCardHeader>
  )
}

export const CardTitle: React.FC<CardTitleProps> = ({
  children,
  className,
}) => {
  return <StyledCardTitle className={className}>{children}</StyledCardTitle>
}

export const CardBody: React.FC<CardBodyProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledCardBody className={className} style={style}>
      {children}
    </StyledCardBody>
  )
}

export const CardFooter: React.FC<CardFooterProps> = ({
  children,
  className,
}) => {
  return <StyledCardFooter className={className}>{children}</StyledCardFooter>
}

export const DataGrid: React.FC<DataGridProps> = ({
  children,
  columns = 1,
  className,
}) => {
  return (
    <StyledDataGrid $columns={columns} className={className}>
      {children}
    </StyledDataGrid>
  )
}

export const DataGroup: React.FC<DataGroupProps> = ({
  children,
  className,
}) => {
  return <StyledDataGroup className={className}>{children}</StyledDataGroup>
}

export const DataRow: React.FC<DataRowProps> = ({
  label,
  value,
  className,
}) => {
  return (
    <StyledDataRow className={className}>
      <StyledDataLabel>{label}</StyledDataLabel>
      <StyledDataValue>{value}</StyledDataValue>
    </StyledDataRow>
  )
}

export const DataSectionTitle: React.FC<DataSectionTitleProps> = ({
  children,
  className,
}) => {
  return (
    <StyledDataSectionTitle className={className}>
      {children}
    </StyledDataSectionTitle>
  )
}
